<template>
    <div class="c-working-hours" tabindex="0" @focus="onFocus" @blur="onBlur" @mouseover="onFocus" @mouseout="onBlur">
        <a role="button" class="c-working-hours__message" @click="onClick">
            <div id="wrapper" class="c-working-hours__labels-wrap c-working-hours__labels-wrap--desktop">
                <div>
                    <div class="phone-icon">
                        <i style="color: #ff6700;" class="u-fa u-fa-phone"></i>
                    </div>
                    <span id="phone" class="phone-block"
                          :style="{fontweight: 'bold', fontSize: smallFont?'22px':'27px', marginTop:smallFont?'10px':'5px', cursor: 'default'}"
                          v-text="telLabel">
                    </span>
                </div>
                <span id="open-data" style="font-size: 11px; cursor: default;" v-text="currentDayWork"></span> |
                <span id="working-hours" style="font-size: 11px;" :class="brandColor"
                      v-text="workingHoursHover"> </span>
            </div>
            <span class="c-working-hours__labels-wrap c-working-hours__labels-wrap--mobile">
                <span class="c-working-hours__button"></span>
                <div class="c-working-hours__text" v-text="contact"></div>
            </span>
        </a>
        <div class="c-working-hours__schedule" v-if="daysFormatted.length > 0 && isVisible">
            <table class="c-working-hours__table">
                <tr>
                    <td colspan="2">
                        <div class="triangle"></div>
                    </td>
                </tr>
                <tr v-for="day in daysFormatted" class="c-working-hours__day"
                    :class="{'is-inactive': day.active !== true, 'is-today': day.today}">
                    <td v-if="day.active === true" v-text="day.name"></td>
                    <td v-if="day.active === true"><span style="float:right;">{{ day.from }} - {{ day.to }}</span></td>
                </tr>
                <tr class="info">
                    <td><span v-text="t('Tel:')"></span></td>
                    <td><a style="float:right;" :href="`tel:${fullTel}`" v-text="shortTel"></a></td>
                </tr>
                <tr class="info">
                    <td><span></span></td>
                    <span v-html="additionalInfo"></span>
                </tr>
                <tr class="info">
                    <td><span v-text="t('Email:')"></span>&nbsp;</td>
                    <td><a :href="`mailto:${email}`" style="text-transform: lowercase;" v-text="email"></a></td>
                </tr>
            </table>

            <table class="c-working-hours__info">
            </table>
        </div>
    </div>
</template>
<script lang="ts">
import forEach from 'lodash/forEach';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const officeScheduleStore = namespace('officeSchedule');

@Component
export default class WorkingHours extends BaseComponent {
    @Prop({type: String, required: true}) protected shortTel: string;
    @Prop({type: String, required: true}) protected fullTel: string;
    @Prop({type: String, required: false}) protected email: string;
    @Prop({type: Boolean, required: true}) protected smallFont: boolean;
    @Prop({type: String}) protected brandColor: string;
    @Prop({type: String, default: ''}) protected additionalInfo: string;

    protected isVisible: boolean = false;
    protected current: string = '';

    @officeScheduleStore.Getter('isOpenNow') protected readonly isOpenNow: boolean;
    @officeScheduleStore.State('days') protected readonly days: any;

    protected get status(): string {
        return this.t(this.isOpenNow ? 'Open' : 'Closed');
    }

    protected get contact(): string {
        return this.t('Contact');
    }

    protected get workingHoursHover(): string {
        return this.t('Working hours');
    }

    protected get telLabel(): string {
        /*return `${this.t('Tel:')} ${this.shortTel}`;*/
        return `${this.t(this.shortTel)}`;
    }

    protected get emailLabel(): string {
        return `${this.t('Email:')} ${this.email}`;
    }

    protected get currentDayIndex(): number {
        return moment().day();
    }

    protected get currentDayWork(): string {
        if (this.current === '') {
            return this.t('Closed today');
        }
        return this.t('Open today') + ' ' + this.current;
    }

    protected get daysFormatted(): any {
        const formatted: any = [];
        forEach(this.days, (day, key) => {
            if (day === null) {
                return;
            }
            const start = moment().startOf('day').add(day.start, 'seconds');
            const end = moment().startOf('day').add(day.end, 'seconds');
            const format = (start.minutes() !== 0 || end.minutes() !== 0) ? 'HH:mm' : 'HH';
            const index = this.getDayIndex(key);

            if (index === this.currentDayIndex) {
                if (day.active) {
                    this.current = start.format(format) + ' - ' + end.format(format);
                }
            }

            formatted.push({
                active: day.active,
                today: index === this.currentDayIndex,
                name: this.t(moment().day(index).format('dddd')),
                from: start.format(format),
                to: end.format(format),
            });
        });

        return formatted;
    }

    protected onClick(): void {
        this.isVisible = !this.isVisible;
    }

    protected onFocus(e): void {
        if (this.onWorkinHours(e)) {
            this.$nextTick(() => this.isVisible = true);
        }
    }

    protected onBlur(): void {
        this.$nextTick(() => this.isVisible = false);
    }

    /**
     * @param {string} dayShortName
     * @returns {number}
     */
    protected getDayIndex(dayShortName: string | number): number {
        switch (dayShortName) {
            case 'mon':
                return 1;
            case 'tue':
                return 2;
            case 'wed':
                return 3;
            case 'thu':
                return 4;
            case 'fri':
                return 5;
            case 'sat':
                return 6;
            case 'sun':
                return 0;
            default:
                return 1;
        }
    }

    private onWorkinHours(e) {
        return (e.target.id !== 'phone' && e.target.id !== 'open-data' && e.target.id !== 'wrapper') ? true : false;
    }

}
</script>
